import React from 'react';
import { Modal, Button } from 'antd';
import { CanvasObject } from '../types';
import { CanvasObjectComponent } from './CanvasObject';
import { ConnectorArrow } from './ConnectorArrow';

interface PreviewModalProps {
    visible: boolean;
    templateName: string;
    objects: CanvasObject[];
    onClose: () => void;
    onSave: () => void;
}

export const PreviewModal: React.FC<PreviewModalProps> = ({
    visible,
    templateName,
    objects,
    onClose,
    onSave
}) => {
    const renderPreviewObject = (obj: CanvasObject) => {
        if ((obj.type as string) === 'connector' || obj.type === 'arrow') {
            return (
                <ConnectorArrow
                    key={obj.id}
                    obj={obj as any}
                    isSelected={false}
                    isPreview={true}
                />
            );
        }
        return (
            <CanvasObjectComponent
                key={obj.id}
                obj={obj}
                isSelected={false}
                isMultiSelected={false}
                onMouseDown={() => { }}
                onMouseMove={() => { }}
                onResizeStart={() => { }}
                isPreview={true}
            />
        );
    };

    return (
        <Modal
            title={`Preview: ${templateName || 'Untitled Template'}`}
            open={visible}
            onCancel={onClose}
            footer={[
                <Button key="close" onClick={onClose}>
                    Close
                </Button>,
                <Button key="save" type="primary" onClick={onSave}>
                    Save Template
                </Button>
            ]}
            width="90%"
            style={{ top: 20 }}
            bodyStyle={{ padding: 0 }}
        >
            <div className="preview-canvas">
                <div className="preview-canvas-inner">
                    <div className="preview-grid" />
                    {objects.map(renderPreviewObject)}

                    {objects.length === 0 && (
                        <div className="preview-empty-state">
                            <div className="empty-icon">🎨</div>
                            <div className="empty-title">No objects to preview</div>
                            <div className="empty-description">Add some text, shapes, or images to see the preview</div>
                        </div>
                    )}
                </div>
            </div>

            <div style={{
                padding: '16px 24px',
                background: '#fafafa',
                borderTop: '1px solid #e8e8e8',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <div>
                    <strong>Template Stats:</strong> {objects.length} objects
                    {objects.filter(obj => obj.type === 'text').length > 0 &&
                        ` • ${objects.filter(obj => obj.type === 'text').length} text elements`}
                    {objects.filter(obj => obj.type === 'image').length > 0 &&
                        ` • ${objects.filter(obj => obj.type === 'image').length} images`}
                    {objects.filter(obj => ['rectangle', 'circle', 'arrow', 'connector'].includes(obj.type)).length > 0 &&
                        ` • ${objects.filter(obj => ['rectangle', 'circle', 'arrow', 'connector'].includes(obj.type)).length} shapes`}
                </div>
                <div style={{ color: '#666', fontSize: 12 }}>
                    Preview shows final template without editing controls
                </div>
            </div>
        </Modal>
    );
};